// DO NOT EDIT -- generated from Go package fs/cook/cookerr

///////////////
// Constants //
///////////////

export const REASON_UNKNOWN: string = "unknownError";
export const REASON_EVENT_RATE_LIMIT: string = "rateLimit";
export const REASON_VARS_MISSING_TYPE: string = "missingFieldType";
export const REASON_VARS_INVALID_NAME: string = "invalidFieldName";
export const REASON_VARS_ID_IMMUTABLE: string = "idsImmutable";
export const REASON_VARS_ID_INVALID: string = "invalidId";
export const REASON_VARS_NAME_TOO_LONG: string = "nameTooLong";
export const REASON_VARS_VALUE_TOO_BIG: string = "valueTooBig";
export const REASON_VARS_TOO_BIG_TO_PARSE: string = "tooBigToParse";
export const REASON_VARS_EXPECTED_PRIMITIVE: string = "expectedAtom";
export const REASON_VARS_INVALID_TYPE: string = "invalidFieldType";
export const REASON_VARS_INVALID_JSON: string = "invalidJson";
export const REASON_VARS_INVALID_VALUE: string = "invalidValue";
export const REASON_VARS_INVALID_EVENT_NAME: string = "invalidEventName";
export const REASON_VARS_EVENT_NAME_CARDINALITY: string = "customNameCardLimit";
export const REASON_VARS_EVENT_PROP_CARDINALITY: string = "customPropCardLimit";
export const REASON_VARS_USER_PROP_CARDINALITY: string = "userCardLimit";
export const REASON_VARS_PAGE_PROP_CARDINALITY: string = "pageCardLimit";
export const REASON_VARS_PAGE_PROP_MAX_PER_PAGE: string = "pageMaxPerPage";
export const REASON_VARS_PAGE_NAME_CHANGED: string = "pageNameChanged";
export const REASON_VARS_UNSET_NAME_MISMATCH: string = "unsetNameMismatched";
export const REASON_VARS_UNMATCHED_UNSET: string = "unmatchedUnset";
export const REASON_VARS_ELEM_PROP_CARDINALITY: string = "elemCardLimit";
export const REASON_VARS_ELEM_PROP_MAX_PER_EVENT: string = "elemMaxPerEvent";
export const REASON_VARS_API_ELEM_CARDINALITY: string = "apiElemCardLimit";
export const ReasonCount: number = 2.5e+01;

////////////
// Arrays //
////////////

export const ReasonTok: string[] = [
  REASON_UNKNOWN,
  REASON_VARS_MISSING_TYPE,
  REASON_VARS_INVALID_NAME,
  REASON_VARS_ID_IMMUTABLE,
  REASON_VARS_ID_INVALID,
  REASON_VARS_NAME_TOO_LONG,
  REASON_VARS_VALUE_TOO_BIG,
  REASON_VARS_TOO_BIG_TO_PARSE,
  REASON_VARS_EXPECTED_PRIMITIVE,
  REASON_VARS_INVALID_TYPE,
  REASON_VARS_INVALID_JSON,
  REASON_VARS_INVALID_VALUE,
  REASON_EVENT_RATE_LIMIT,
  REASON_VARS_INVALID_EVENT_NAME,
  REASON_VARS_EVENT_NAME_CARDINALITY,
  REASON_VARS_EVENT_PROP_CARDINALITY,
  REASON_VARS_USER_PROP_CARDINALITY,
  REASON_VARS_PAGE_PROP_CARDINALITY,
  REASON_VARS_PAGE_PROP_MAX_PER_PAGE,
  REASON_VARS_PAGE_NAME_CHANGED,
  REASON_VARS_UNSET_NAME_MISMATCH,
  REASON_VARS_UNMATCHED_UNSET,
  REASON_VARS_ELEM_PROP_CARDINALITY,
  REASON_VARS_ELEM_PROP_MAX_PER_EVENT,
  REASON_VARS_API_ELEM_CARDINALITY,
];
